import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../environments/config';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class CustomerGuideHseDocumentsService {
    public apiUrl = config.API_ROOT;
    public headers: Headers = new Headers();
    public options: RequestOptions;
    public progress$: Observable<number>;
    public progress: number;
    public progressObserver: any;

    constructor(
        public http: Http,
        public router: Router
    ) {
        this.progress = 0;
        if (tokenNotExpired())
            this.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
        
        this.options = new RequestOptions({ headers: this.headers });
        this.progress$ = new Observable(observer => {
            this.progressObserver = observer;
        });
    }

    public getAttachmentCustomerGuide(customer_guide_id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/documents-customer-guide?customer_guide_id=${customer_guide_id}`,  { headers: this.headers } );
    }

    public updateAttachmentCustomerGuide(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/documents-customer-guide/${id}/attachment`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getAttachmentDocumentCustomerGuide(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/documents-customer-guide/${id}/download-attachment`, options);
    }

    public addAttachmentDocumentCustomerGuide(files: File[], customer_guide_id: number, list_customer_guide_hse_id: number): Observable<Response> {
        let url = `${this.apiUrl}/documents-customer-guide/`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i], files[i].name);
        }
        
        formData.append('customer_guide_id', customer_guide_id.toString());
        
        formData.append('list_customer_guide_hse_id', list_customer_guide_hse_id.toString());

        return this.http.post(url, formData, this.options);
    }

    public deleteAttachmentDocumentCustomerGuide(id:number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/documents-customer-guide/${id}`, { headers: this.headers } );
    }

    public getListHseDocumentsCustomerGuide(customer_guide_id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/documents-customer-guide/hse-list-documents?customer_guide_id=${customer_guide_id}`,  { headers: this.headers } );
    }

}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/customer-guide-hse-document/customer-guide-hse-document.service.ts